import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18850fa7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-4 mb-xxl-4 rounded-radius" }
const _hoisted_2 = { class: "card-body pt-4 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-4 ps-2" }
const _hoisted_4 = { class: "me-4 platform-image" }
const _hoisted_5 = { class: "d-flex w-100 align-items-center" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-start flex-wrap flex-grow-1" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "d-flex align-items-center gap-4" }
const _hoisted_9 = { class: "badge-light-primary badge fs-9 text-primary p-3" }
const _hoisted_10 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-1 px-4 me-6 align-items-center d-flex gap-4" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  class: "fs-6 fw-bold mb-0",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bold fs-8 text-gray-400 mb-0" }, "Due Date", -1))
const _hoisted_14 = { class: "d-flex flex-wrap" }
const _hoisted_15 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_16 = { class: "d-flex flex-wrap" }
const _hoisted_17 = { class: "min-w-125px px-4 me-6" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "flex-grow-1" }
const _hoisted_20 = { class: "text-muted d-block fw-bold fs-8" }
const _hoisted_21 = { class: "d-flex overflow-auto ps-6 list-nav" }
const _hoisted_22 = { class: "nav align-items-center nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap gap-16" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "el-dropdown-link nav-link text-active-primary me-0 px-2 mb-0 d-flex align-items-center" }
const _hoisted_28 = { class: "svg-icon svg-icon-6 ms-1" }
const _hoisted_29 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_avatar, { shape: "square" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.platform?.ticketsPrefix), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: { name: 'platform-overview' },
                    class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.platform && _ctx.platform.name), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("progress")), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.platform && _ctx.platform.releaseDate), 1)
                    ]),
                    _hoisted_13
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_avatar, {
                        class: "me-4",
                        "first-name": _ctx.platform?.users?.firstName,
                        "last-name": _ctx.platform?.users?.lastName
                      }, null, 8, ["first-name", "last-name"]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: "#",
                          class: "text-dark fw-bold text-hover-primary fs-6"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.platform?.users?.firstName) + " " + _toDisplayString(_ctx.platform?.users?.lastName), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("platform")) + " | " + _toDisplayString(_ctx.$t("administrator")), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: { name: 'platform-overview' },
                class: "nav-link text-active-primary me-0 px-2",
                "active-class": "active",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("profileOverview")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-0 px-2",
                to: { name: 'platform_targets' },
                "active-class": "active",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tickets")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_25, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-0 px-2",
                to: { name: 'files' },
                "active-class": "active",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("files")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [
                  (_ctx.platform)
                    ? (_openBlock(), _createBlock(_component_el_dropdown_menu, {
                        key: 0,
                        "hide-timeout": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platform.projects, (project, index) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              class: "me-0 text-dark text-hover-primary",
                              key: index,
                              to: {
                      name: project.name == 'API' ? 'amplication' : 'mindmap',
                      params: {
                        projectId:
                          project.name == 'API'
                            ? project.amplicationAppId
                            : project.id,
                      },
                    },
                              "active-class": "active"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(project.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_ctx.$t("platformsInfo.projects")) + " ", 1),
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_inline_svg, { src: "svg/icons/chevron-down.svg" })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_29, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-0 px-2",
                "active-class": "active",
                to: { name: 'platform-activity' },
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("activity")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}